/**
 * Session UI translations – single source of truth.
 *
 * These translations cover all text rendered by @selna/session-ui components
 * (session header, controls, error states, microphone prompts, etc.).
 *
 * Consuming apps should import and deep-merge these into their own i18next
 * resources so the UI is correctly localised.
 *
 * Language codes use the full BCP-47 format used by the frontend i18n config.
 */

import en from './en.json';
import pt from './pt.json';
import fr from './fr.json';
import es from './es.json';
import da from './da.json';

/** All session-ui translations keyed by i18n language code. */
export const sessionUITranslations: Record<string, Record<string, unknown>> = {
  'en-US': en,
  'pt-PT': pt,
  'fr-FR': fr,
  'es-ES': es,
  'da-DK': da,
};

/**
 * Get session-ui translations for a specific language.
 * Falls back to English if the language is not supported.
 */
export function getSessionUITranslations(lang: string): Record<string, unknown> {
  return sessionUITranslations[lang] ?? en;
}

// Also export individual language bundles for direct import
export { en, pt, fr, es, da };
